import { lazy } from "react";
export var GlossaryEditPageAsync = lazy(function () { return import("./GlossaryEditPage"); });
